import { Accessor, Component, createSignal, Show } from "solid-js";
import { cleanImagePath } from "./API";
import { ArtworkItem, ArtworkMasonry } from "./components/artwork-masonry";
import { AddToCollectionModal } from "./components/add-to-collection-modal";

export type ArtworkLocation = {
    id: number;
    name: string;
    details: string;
    url: string;
};
export type Artwork = {
    id: number;
    showHiresIcon: boolean;
    alternateTitle: string;
    translateTitle: string;
    medium: string;
    measurements: string;
    credit: string;
    content: string;
    artworkLocation?: ArtworkLocation;
    imageCount: number;
    imageHeight: number;
    imageWidth: number;
    isForSale: boolean;
    isSold: boolean;
    dateRange: string;
    dateAdded: string;
    title: string;
    url: string;
    primaryImageUrl: string;
    backgroundColor: string;
};

type ArtworksBlocksProps = {
    artworks: Accessor<Artwork[]>;
    imageBackgroundColor?: string;
    isLoggedIn: boolean;
}
export const ArtworksBlocks : Component<ArtworksBlocksProps> =(props) => {
    const [showModal, setShowModal] = createSignal<boolean>(false);
    const [selectedArtworkId, setSelectedArtworkId] = createSignal<string>("");
    const [showBlockTextForArtworkId, setShowBlockTextForArtworkId] = createSignal<number|null>(null);
    const closeAddToCollectionModal = () => setShowModal(false);
    const onAddToCollectionClicked = (item: ArtworkItem) => {
        setSelectedArtworkId(item.Id);
        setShowModal(true);
    }
    const toArtworkItems = (artworks: Artwork[]) => {
        return artworks
            .filter(x=> !!x.imageWidth && !!x.imageHeight)
            .map(x => ({
                Id: x.id + "",
                Title: x.title,
                URL: x.url,
                Width: x.imageWidth,
                Height: x.imageHeight,
                PrimaryImage: {
                    URL: cleanImagePath(x.primaryImageUrl)
                }} as ArtworkItem)
            );
    }
    return (
        <>
            <div class="finalist-grid" style="min-height: 600px;">
                <ArtworkMasonry 
                    isLoggedIn={props.isLoggedIn}
                    artworks={toArtworkItems(props.artworks())}
                    onAddToCollectionClicked={onAddToCollectionClicked}
                />
            </div>
            <Show when={showModal()}>
                <AddToCollectionModal
                    artworkId={selectedArtworkId}
                    showModal={showModal}
                    onClose={closeAddToCollectionModal}
                />
            </Show>
        </>
    );
}